export const SESSION_IDLE_TIME_MINS = 1440;
export const AUTO_LOGOFF_TIMEOUT_SECS = 30;
